export default __webpack_public_path__ + "static/media/workers.e07579ce.svg";